import { Box } from '@mui/material';
import React from 'react';

export default function NotFound() {
  return <Box sx={{ m: 'auto', p: 20, textAlign: 'center' }}>ページが見つかりません</Box>;
}
